const configuredBackend = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
export const API_BASE = configuredBackend ? `${configuredBackend}/api` : "/api";

export class ApiError extends Error {
  constructor(message, { status = 0, code = "REQUEST_FAILED", details, correlationId } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = details;
    this.correlationId = correlationId;
  }
}

export function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`;
  const item = String(document.cookie || "").split(";").map((part) => part.trim()).find((part) => part.startsWith(prefix));
  if (!item) return "";
  try { return decodeURIComponent(item.slice(prefix.length)); } catch { return ""; }
}

export function apiUrl(path) {
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

export async function apiFetch(path, options = {}) {
  const method = String(options.method || "GET").toUpperCase();
  const headers = new Headers(options.headers || {});
  const init = { ...options, method, headers, credentials: "include" };

  if (options.body !== undefined && options.body !== null && !(options.body instanceof FormData) && !(options.body instanceof Blob) && typeof options.body !== "string") {
    headers.set("content-type", "application/json");
    init.body = JSON.stringify(options.body);
  }
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const csrfToken = readCookie("hse_csrf");
    if (csrfToken) headers.set("X-CSRF-Token", csrfToken);
  }

  let response;
  try {
    response = await fetch(apiUrl(path), init);
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    throw new ApiError("The server could not be reached.", { code: "NETWORK_ERROR" });
  }

  const contentType = response.headers.get("content-type") || "";
  let body = null;
  if (response.status !== 204) {
    try { body = contentType.includes("application/json") ? await response.json() : await response.text(); }
    catch { body = null; }
  }
  if (!response.ok) {
    const error = body?.error;
    const apiError = new ApiError(
      (typeof error === "object" ? error?.message : error) || "The request could not be completed.",
      {
        status: response.status,
        code: (typeof error === "object" ? error?.code : null) || "REQUEST_FAILED",
        details: typeof error === "object" ? error?.details : undefined,
        correlationId: body?.correlationId || response.headers.get("x-correlation-id") || undefined,
      }
    );
    if (response.status === 401 && path !== "/auth/login") {
      window.dispatchEvent(new CustomEvent("hse:session-expired", { detail: apiError }));
    }
    throw apiError;
  }
  return body;
}
